/**
 * Hooks de apoio a formulários LiveView.
 */

export const ClearFormError = {
  mounted() {
    this.el.addEventListener('input', () => {
      const form = this.el.closest('form');
      if (form) {
        const errorElements = form.querySelectorAll('.error-message');
        errorElements.forEach((element) => {
          element.style.display = 'none';
        });
      }
    });
  }
};

export const PreventFormReset = {
  mounted() {
    this.formData = new Map();
    this.saveFormData();
    this.setupEventListeners();
  },

  updated() {
    this.restoreFormData();
  },

  setupEventListeners() {
    this.el.addEventListener('input', () => {
      this.saveFormData();
    });

    this.el.addEventListener('change', () => {
      this.saveFormData();
    });
  },

  saveFormData() {
    const formData = new FormData(this.el);
    this.formData.clear();

    for (let [key, value] of formData.entries()) {
      this.formData.set(key, value);
    }

    const checkboxes = this.el.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      this.formData.set(`${checkbox.name}_checked`, checkbox.checked);
    });
  },

  restoreFormData() {
    if (this.formData.size === 0) return;

    for (let [key, value] of this.formData.entries()) {
      if (key.endsWith('_checked')) continue;

      const input = this.el.querySelector(`[name="${key}"]`);
      if (input && input.value !== value) {
        input.value = value;
      }
    }

    const checkboxes = this.el.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      const checkedKey = `${checkbox.name}_checked`;
      if (this.formData.has(checkedKey)) {
        checkbox.checked = this.formData.get(checkedKey);
      }
    });
  }
};

export const DirectFileInput = {
  mounted() {
    this.el.addEventListener('change', () => {
      if (this.el.files && this.el.files[0]) {
        const file = this.el.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
          const preview = event.target.result;
          const inputId = this.el.id || '';
          let eventName = 'direct-file-upload';

          if (inputId.includes('client')) {
            eventName = 'client_logo_upload';
          } else if (inputId.includes('dining_hall')) {
            eventName = 'dining_hall_logo_upload';
          } else if (inputId.includes('department')) {
            eventName = 'department_logo_upload';
          }

          const previewImg = document.getElementById('logo-preview-img');
          const placeholder = document.getElementById('logo-preview-placeholder');

          if (previewImg && placeholder) {
            previewImg.src = preview;
            previewImg.style.display = 'block';
            placeholder.style.display = 'none';
          }

          this.pushEvent(eventName, {
            preview,
            filename: file.name,
            type: file.type,
            size: file.size
          });
        };

        reader.readAsDataURL(file);
      }
    });
  }
};

export const FormRuntimeHooks = {
  ClearFormError,
  PreventFormReset,
  DirectFileInput
};
